import { render, staticRenderFns } from "./CsatMetrics.vue?vue&type=template&id=3c0fe985&scoped=true&"
import script from "./CsatMetrics.vue?vue&type=script&lang=js&"
export * from "./CsatMetrics.vue?vue&type=script&lang=js&"
import style0 from "./CsatMetrics.vue?vue&type=style&index=0&id=3c0fe985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0fe985",
  null
  
)

export default component.exports